
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux"; // add useSelector
import { useLocation, useNavigate } from "react-router-dom";
import ReportTable from "../../ReportTable";
import { useReport } from "../../hooks/useReport";
import { batchUpdateAppliedFilters } from "../../redux/ReportsSlice";

const REPORT_PATH = "/codingkpis-coder-report";

const CodingKpisCoderOverview = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const coderName = location.state?.coderName  ?? "Coder";
  const userId = location.state?.user_id;
const startDate = location.state?.start_date;
const endDate = location.state?.end_date;

  const appliedFilters = useSelector(
    (s) => s.reports.appliedFilters[REPORT_PATH] || {}
  );
  const filtersReady = !!(appliedFilters?.start_date && appliedFilters?.end_date);
  

  useEffect(() => {
  if (!userId) {
    console.log(" userId missing → API won't work");
    return;
  }

    dispatch(
      batchUpdateAppliedFilters({
        reportPath: REPORT_PATH,
        filters: {
          user_id:              userId ? [userId] : [],
          start_date:           startDate,
          end_date:             endDate,
          site:                 [],
          speciality:        [],
          drg:                  [],
          validation:           [],
          discharge_date:       [],
          no_of_codes:          [],
          no_of_codes_operator: "",
          los:                  [],
          los_operator:         "",
          nwau:                 [],
          nwau_operator:        "",
          sort_by:              "",
          sort_order:           "",
        },
      })
    );
  }, []);

  const {
    episodes,
    reportData,
    totalPages,
    pageNumber,
    setPageNumber,
    searchText,
    setSearchText,
    handleSearchChange,
    reportLoading,
    reportError,
    exportLoading,
    handleReset,
    resetSignal,
    setSortPayload,
  } = useReport(REPORT_PATH);
  

  const handleColumnFilterApply = useCallback(
    (filters) => {
      dispatch(
        batchUpdateAppliedFilters({
          reportPath: REPORT_PATH,
          filters: {
            ...appliedFilters, // always preserve user_id, start_date, end_date
            ...filters,
          },
        })
      );
      setPageNumber(1);
    },
    [dispatch, setPageNumber, appliedFilters]
  );

  return (
    <div className="hac-report-table-container mt-3 px-2">
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
        <h4 className="pb-2">Coding KPI Stats — {coderName}</h4>
        <button className="kpi-reset"   onClick={() => navigate({ pathname: "/coding-kpis-report", search: "?view=table" })}
>
          Back
        </button>
      </div>

      <ReportTable
        episodes={episodes}
        isReportLoading={reportLoading}
        isReportError={reportError}
        reportPageNumber={pageNumber}
        setReportPageNumber={setPageNumber}
        reportExcelLoading={exportLoading}
        handleSearchChange={handleSearchChange}
        totalPages={totalPages}
        searchText={searchText}
        setSearchText={setSearchText}
        onSortChange={setSortPayload}
        // onReset={handleReset}
        resetSignal={resetSignal}
        onColumnFilterApply={handleColumnFilterApply}
        reportData={reportData}
      />
    </div>
  );
};

export default CodingKpisCoderOverview;